/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Muddy_Crab_SparkInputs */

const fr_wide_muddy_crab_spark = /** @type {(inputs: Wide_Muddy_Crab_SparkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sauvegarder`)
};

/**

* @param {Wide_Muddy_Crab_SparkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const wide_muddy_crab_spark = /** @type {((inputs?: Wide_Muddy_Crab_SparkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Muddy_Crab_SparkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_wide_muddy_crab_spark(inputs)
});